import { useMemo } from 'react';
import { EmbedWidget } from './components/EmbedWidget';

export const EmbedPage: React.FC = () => {
  const thumbnailOptions = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    
    const exhibitorSlug = params.get('exhibitorSlug');
    const librarySlug = params.get('librarySlug');
    
    // exhibitorSlugとlibrarySlugは必須
    if (!exhibitorSlug || !librarySlug) {
      return {
        exhibitorSlug: 'dhowa-technos', // デフォルト値
        librarySlug: 'moxa' // デフォルト値
      };
    }
    
    return {
      exhibitorSlug,
      librarySlug
    };
  }, []);

  return (
    <div className="w-full h-screen flex items-center justify-center" style={{ backgroundColor: 'transparent' }}>
      <EmbedWidget
        {...thumbnailOptions}
      />
    </div>
  );
};